const APP_GETTERS = {
  coins: 'app/coins',
  loading: 'app/loading',
}

const APP_DISPATCHERS = {
  getCoins: 'app/getCoins',
  copyToClipboard: 'app/copyToClipboard',
  copyFileToClipboard: 'app/copyFileToClipboard',
}

export { APP_GETTERS, APP_DISPATCHERS }
